import { GetterTree } from 'vuex'
import CategoriesState from '../../types/CategoriesState'
import RootState from '@vue-storefront/core/types/RootState'

const getters: GetterTree<CategoriesState, RootState> = {
  getCategories: (state) => state.categories,
  getActivePartnersCategory: state => state.current_category,
  getCategoryByCode: state => code => state.categories.find(cat => cat.code === code),
  getCategoryById: state => id => state.categories.find(cat => cat.entity_id === id),
  getLoadedForLocationCode: state => state.loadedForLocationCode
}

export default getters
